<div fxLayout="column" fxFlex fxLayoutGap="20px">
    <json-template-object
        fxFlex
        isOpen="true"
        [name]="rootName"
        [configHeader]="configHeader"
        [isSource]="true"
        [isJsonBuilderRoot]="true"
        [breadcrumb]="breadcrumb"
        [data]="data"
        (deleteEvent)="delete()"
        (deleteAllEvent)="delete()"
        *ngIf="(data | json) !== '{}';">
    </json-template-object>
    <json-template-button-add-attribute 
        fxFlex 
        [config]="configButtonAddAttribute"
        (addAttributeEvent)="addAttribute($event)">
    </json-template-button-add-attribute>
</div>
